import { Button, CircularProgress, TextField } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import AppleAuthForm from "../../../components/Forms/AppleAuthForm";
import FaceBookAuthForm from "../../../components/Forms/FaceBookAuthForm";
import GoogleAuthForm from "../../../components/Forms/GoogleAuthForm";
import InstagramAuthForm from "../../../components/Forms/InstagramAuthForm";
import { AuthContext } from "../../../context/AuthContext";
import { CloseIcon } from "../../../icons";
import "../../../pages/signup/signup.css";
import EmailVerification from "../EmailVerification/EmailVerification";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OTPTimer from "../../../utils/OTPTimer";
import { Col, Row } from "react-grid-system";
import { Link, useHistory, useLocation } from "react-router-dom";
import { CustomButton } from "../../../components/Button/Button";
import { phoneRegExp } from "../../../utils/common";
import { userServices } from "../../../services";
import { SnackbarContext } from "../../../context/SnackbarContext";
import { config } from "../../../assets/config/config";

export default function Signin({ open, onClose }) {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();
  const history = useHistory();
  const {
    setIsSignUpPopup,
    setIsSignInPopup,
    setUser,
    setAccessToken,
    startSilentRefresh,
    GetSignUpDependency,
    setLoaded,
    setSignInTabs,
    isJobapply,
    checkNewNotification,
    setIsProfileFreezed,
    signInTabs,
  } = useContext(AuthContext);
  const { openSnackbar, closeSnackbar } = useContext(SnackbarContext);
  const location = useLocation();
  const isFindJob = location?.pathname?.includes("find-jobs")
    ? location?.pathname?.split("/")?.pop()
    : null;
  const [openMenu, setOpenMenu] = useState(open);
  const [OpenemailVerify, setOpenemailVerify] = useState(false);
  const [role, setRole] = useState(1);
  const [otpScreen, setOtpScreen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [invaildNum, setInvaildNum] = useState(false);
  const [invaildOtp, setinvaildOtp] = useState(false);
  const [roleData, setRoleData] = useState(
    pathname == "/recruiters" ? 1 : pathname == "/talents" ? 0 : -1
  );

  //with otp
  const [time, setTime] = useState(180);
  const [showResend, setShowResend] = useState(false);
  const [opt1, setOtp1] = useState(null);
  const [otp2, setOtp2] = useState(null);
  const [otp3, setOtp3] = useState(null);
  const [otp4, setOtp4] = useState(null);
  const otp1Ref = useRef();
  const otp2Ref = useRef();
  const otp3Ref = useRef();
  const otp4Ref = useRef();

  const [accountStatus, setAccountStatus] = useState("");

  const handleClose = () => {
    setOpenMenu(false);
    onClose(false);
    setMobileNumber("");
    setAccountStatus(null);
    setEmailError(null);
    setRoleData(-1);
    setSignInTabs(null);
  };

  useEffect(() => {
    if (signInTabs === "recruiter") {
      setRoleData(1);
    } else if (signInTabs === "Talent") {
      setRoleData(0);
    }
  }, [signInTabs]);

  const openVerification = () => {
    setOpenemailVerify(true);
    handleClose();
  };
  useEffect(() => {
    setOpenMenu(open);
    pathname == "/" && setRoleData(-1);
    pathname == "/recruiters" && setRoleData(1);
    pathname === "/talents" && setRoleData(0);
    pathname === "/find-talents" && setRoleData(1);
    pathname.includes("/talent/") && setRoleData(1);
    pathname.includes("/recruiter/") && setRoleData(-1);
    pathname.includes("/talent/") && setRoleData(1);
    pathname.includes("/jobs/") && setRoleData(0);
    pathname === "/find-jobs" && setRoleData(0);
  }, [open]);

  const closemodel = () => {
    onClose(false);
    setOpenMenu(false);
    setOpenemailVerify(false);
  };
  const dateCheck = (event) => {
    let d = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1");
    return d;
  };
  const handleSignin = () => {
    setAccountStatus(null);
    setIsSubmitting(true);
    userServices
      .VerifyUserWithNum(mobileNumber)
      .then((resp) => {
        if (resp.data.httpCode == 500) {
          setAccountStatus(resp?.data?.message);
          return;
        }

        if (resp.data.httpCode == 200) {
          openSnackbar(resp.data.message);
          setOtpScreen(true);
          setinvaildOtp(false);
        } else {
          setInvaildNum(true);
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  const handleVerifyOtp = () => {
    setIsSubmitting(true);
    userServices
      .VerifyUserWithNumOtp(mobileNumber, `${opt1 + otp2 + otp3 + otp4}`)
      .then((resp) => {
        if (resp.data.httpCode === 400) {
          setinvaildOtp(true);
        } else {
          setUser(resp.data.user);
          setAccessToken(resp.data.token);
          startSilentRefresh();
          GetSignUpDependency();
          if (resp.data.user?.isFreezed) {
            setIsProfileFreezed(resp.data.user.isFreezed);
          } else {
            setIsProfileFreezed(false);
          }
          if (isJobapply === true || isFindJob) {
            closemodel();
          } else {
            if (resp.data.user.user_type == 1) {
              if (resp.data.user?.talenter?.is_profile_creation_completed) {
                history.push(`/talent/${resp.data.user?.userUniqueId}`);
              } else {
                history.push(`/app/dashboard`);
              }
            } else {
              if (resp.data.user.user_type == 2) {
                // history.push(`/find-talents`);
                if (resp.data.user?.recruiter?.is_profile_creation_completed) {
                  history.push(`/app/my-projects`);
                } else {
                  history.push(
                    `/app/recruiter-form/${resp.data.user.userUniqueId}`
                  );
                }
              }
            }

            closemodel();
          }

          setLoaded(true);
          setOtpScreen(false);
          setMobileNumber("");
          setOtp1(null);
          setOtp2(null);
          setOtp3(null);
          setOtp4(null);
          setinvaildOtp(false);
          var userType = resp.data.user.user_type == 1 ? "Talent" : "Recruiter";
          var userUrl =
            resp.data.user.user_type == 1
              ? `href="${config.admin_url}/app/talent-management/profile/${resp.data.user?.user_id}"`
              : `href="${config.admin_url}/app/recruiter/details/${resp.data.user?.user_id}"`;
          const payload = {
            user_id: `${resp.data.user?.user_id}`,
            message: `<p><a class="talent_name" ${userUrl}>${resp.data.user?.first_name} (${userType} ${resp.data.user?.user_id})</a> signed in using MobileOTP</p>`,
          };
          checkNewNotification(resp.data.user?.user_id);
          userServices.createLog(payload);
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const ResendOtp = () => {
    setOtp1(null);
    setOtp2(null);
    setOtp3(null);
    setOtp4(null);
    otp1Ref.current.value = "";
    otp2Ref.current.value = "";
    otp3Ref.current.value = "";
    otp4Ref.current.value = "";
    setinvaildOtp(false);
    setTime(10);
    setShowResend(false);
    userServices.VerifyUserWithNum(mobileNumber).then((resp) => {});
  };
  const navigatetoContact = () => {
    setIsSignUpPopup(false);
    setIsSignInPopup(false);
    history.push("/about/contact-us");
  };

  return (
    <>
      <EmailVerification
        open={OpenemailVerify}
        onClose={closemodel}
        back={() => {
          setOpenMenu(true);
          setOpenemailVerify(false);
        }}
      />
      <div
        className={openMenu ? "overlay block" : "hidden"}
        onClick={handleClose}
      ></div>
      <div
        className={openMenu ? "singup__screen signup_open" : "singup__screen"}
      >
        {!otpScreen ? (
          <>
            {" "}
            <div className="signup__header flex justify-between items-center">
              <h4 className="font-semibold text-gray-700 signup__title">
                {roleData >= 0
                  ? `Sign In as a ${roleData == 1 ? "Recruiter" : "Talent"}`
                  : "Sign In"}
              </h4>
              <CloseIcon className="close_icon" onClick={handleClose} />
            </div>
            <div className="role_selecter flex">
              <span
                className={
                  role === 0
                    ? "text-center role_btn role_active"
                    : "text-center role_btn"
                }
                onClick={() => {
                  setRole(0);
                  setAccountStatus(null);
                }}
              >
                with OAuth
              </span>
              <span
                className={
                  role === 1
                    ? "text-center role_btn role_active"
                    : "text-center role_btn"
                }
                onClick={() => {
                  setRole(1);
                  setAccountStatus(null);
                }}
              >
                with Mobile & OTP
              </span>
            </div>
            {emailError === true ? (
              <div className="errMsgcontainer p-4 mb-3">
                {" "}
                <p className="emailErrText " style={{ marginBottom: 25 }}>
                  Oops! We need an email!{" "}
                </p>
                <p className="fontStyl" style={{ marginBottom: 25 }}>
                  Sorry, we could not find the email address linked to your
                  Sign-up choice.{" "}
                </p>
                <p className="fontStyl">
                  Please <b>use another Sign-up</b> option.
                </p>
              </div>
            ) : null}
            {accountStatus === "Deleted" && (
              <div className="errMsgcontainer p-4 mb-3">
                {" "}
                <p className="emailErrText " style={{ marginBottom: 10 }}>
                  Profile Deleted
                </p>
                <p className="fontStyl">
                  Sorry, this profile no longer exists. Please{" "}
                  <span onClick={navigatetoContact} className="linkText">
                    contact
                  </span>{" "}
                  the admin for more information.
                </p>
              </div>
            )}
            {accountStatus === "Banned" ? (
              <div className="errMsgcontainer p-4 mb-3">
                {" "}
                <p className="emailErrText " style={{ marginBottom: 10 }}>
                  Profile Banned
                </p>
                <p className="fontStyl">
                  Sorry, your profile is banned and you won’t be able to login
                  or create another profile using the same credentials. Please{" "}
                  <span onClick={navigatetoContact} className="linkText">
                    contact
                  </span>{" "}
                  the admin for more information.{" "}
                </p>
              </div>
            ) : accountStatus === "Locked" ? (
              <div className="errMsgcontainer p-4 mb-3">
                {" "}
                <p className="emailErrText " style={{ marginBottom: 10 }}>
                  Profile Locked
                </p>
                <p className="fontStyl">
                  Sorry, your profile is locked and you will not be able login.
                  Please{" "}
                  <span onClick={navigatetoContact} className="linkText">
                    contact
                  </span>{" "}
                  the admin for more information.{" "}
                </p>
              </div>
            ) : accountStatus === "Freeze" ? (
              <div className="errMsgcontainer p-4 mb-3">
                {" "}
                <p className="emailErrText " style={{ marginBottom: 10 }}>
                  Profile Freeze
                </p>
                <p className="fontStyl">
                  Sorry, your profile is under freeze and you will not be able
                  to apply to new jobs or make any changes to the profile.
                  Please{" "}
                  <span onClick={navigatetoContact} className="linkText">
                    contact
                  </span>{" "}
                  the admin for more information.
                </p>
              </div>
            ) : (
              accountStatus?.length > 7 && (
                <div className="errMsgcontainer p-4 mb-3">
                  <p className="emailErrText " style={{ marginBottom: 10 }}>
                    Error{" "}
                  </p>
                  <p className="fontStyl">{accountStatus}</p>
                </div>
              )
            )}
            <div className="form__container">
              {role === 0 ? (
                <>
                  <GoogleAuthForm
                    closemodel={closemodel}
                    name="Sign in with Google"
                    setAccountStatus={setAccountStatus}
                    isLogin={true}
                  />
                  <FaceBookAuthForm
                    closemodel={closemodel}
                    name="Sign in with Facebook"
                    setAccountStatus={setAccountStatus}
                    setEmailError={setEmailError}
                    isLogin={true}
                  />
                  {/* <InstagramAuthForm closemodel={closemodel} name='Sign in with Instagram' /> */}

                  {/* <AppleAuthForm closemodel={closemodel} name='Sign in with Apple' /> */}

                  <h6 className="footer_text text-center mt-5 mr-10">
                    Don't have an account?{" "}
                    <span
                      className="link"
                      onClick={() => {
                        setIsSignInPopup(false);
                        setIsSignUpPopup(true);
                      }}
                    >
                      <b>Sign up</b>
                    </span>
                  </h6>
                </>
              ) : (
                <div className="overflow-auto">
                  <div className="input_container mt-2">
                    <label>Enter your 10-digit registered mobile number</label>
                    <input
                      className="casting_input"
                      name="first_name"
                      autoComplete="off"
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          setMobileNumber(e.target.value);
                          if (
                            e.target.value.length === 10 &&
                            !e.target.value.match(phoneRegExp)
                          ) {
                            setInvaildNum(true);
                          } else if (
                            e.target.value.length === 10 &&
                            e.target.value.match(phoneRegExp)
                          ) {
                            setInvaildNum(false);
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.target.value.length == 10 && e.key === "Enter") {
                          handleSignin();
                        }
                      }}
                      value={mobileNumber}
                      // onBlur={handleBlur}
                    ></input>
                    <span className="text-xs text-red-600 dark:text-red-400">
                      {invaildNum
                        ? mobileNumber.length == 0
                          ? "Please enter your registered 10-digit Whatsapp number"
                          : "Please enter a vaild mobile number"
                        : null}
                    </span>
                  </div>
                  {/* <div className='w-'> */}
                  <div className="flex justify-center mt-4 mb-4 custom_wd">
                    <div className="top_title w-full">
                      <CustomButton
                        text={"Sign in"}
                        style={{ width: "100%", padding: "8px 0" }}
                        disabled={isSubmitting}
                        onClick={() => {
                          if (mobileNumber.match(phoneRegExp)) {
                            handleSignin();
                          } else {
                            setInvaildNum(true);
                          }
                        }}
                        isLoading={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* </div> */}
                  <GoogleAuthForm
                    closemodel={closemodel}
                    name="Sign in with Google"
                    setAccountStatus={setAccountStatus}
                    isLogin={true}
                  />
                  <FaceBookAuthForm
                    closemodel={closemodel}
                    name="Sign in with Facebook"
                    setAccountStatus={setAccountStatus}
                    setEmailError={setEmailError}
                    isLogin={true}
                  />
                  {/* <InstagramAuthForm closemodel={closemodel} name='Sign in with Instagram' /> */}

                  {/* <AppleAuthForm closemodel={closemodel} name='Sign in with Apple' /> */}

                  <h6 className="footer_text text-center mt-5 mr-10">
                    Don't have an account?{" "}
                    <span
                      className="link"
                      onClick={() => {
                        setIsSignInPopup(false);
                        setIsSignUpPopup(true);
                      }}
                    >
                      <b>Sign up</b>
                    </span>
                  </h6>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="signup__header flex justify-between items-center">
              <div className="flex justify-center items-center gap-4">
                <ArrowBackIcon
                  size={"20px"}
                  sx={{ color: "#979797" }}
                  onClick={() => setOtpScreen(false)}
                  className="cursor-pointer"
                />
                <h4 className="font-semibold text-gray-700 signup__title">
                  Verification
                </h4>
              </div>
              <CloseIcon
                className="close_icon"
                onClick={() => setOtpScreen(false)}
              />
            </div>
            <div style={{ marginTop: '20px' }}> {/* Adjust '20px' as needed */}
    <label>Enter <b>OTP</b> sent as <b>SMS</b> to <span style={{ fontWeight: '600', color: '#9B26B6' }}>{mobileNumber}</span></label>

              <form>
                <div className="top_heading_content">
                  <div className="sign_opt_inner">
                    <div
                      className={`opt_left ${invaildOtp && "otp_error_value"}`}
                    >
                      <TextField
                        autoFocus
                        id="standard-basic"
                        variant="standard"
                        inputRef={otp1Ref}
                        inputProps={{
                          autocomplete: "new-password",
                          form: { autocomplete: "off" },
                        }}
                        onChange={(e) => {
                          setinvaildOtp(false);
                          if (
                            e.target.value.length <= 1 &&
                            otp2Ref.current &&
                            dateCheck(e) != ""
                          ) {
                            if (dateCheck(e) != "") {
                              setOtp1(e.target.value);
                              otp2Ref.current.focus();
                            }
                          } else {
                            e.preventDefault();
                            otp1Ref.current.value = "";
                          }
                        }}
                        name="otp_screen"
                      />
                    </div>
                    <div
                      className={`opt_left ${invaildOtp && "otp_error_value"}`}
                    >
                      <TextField
                        id="standard-basic"
                        inputRef={otp2Ref}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) {
                            e.preventDefault();
                            otp2Ref.current.value = "";
                            otp1Ref.current.focus();
                          }
                        }}
                        onChange={(e) => {
                          setinvaildOtp(false);
                          if (
                            e.target.value.length <= 1 &&
                            otp3Ref.current &&
                            dateCheck(e) != ""
                          ) {
                            if (dateCheck(e) != "") {
                              setOtp2(e.target.value);
                              otp3Ref.current.focus();
                            }
                          } else {
                            e.preventDefault();
                            otp2Ref.current.value = "";
                          }
                        }}
                        variant="standard"
                        name="otp_screen"
                      />
                    </div>
                    <div
                      className={`opt_left ${invaildOtp && "otp_error_value"}`}
                    >
                      <TextField
                        id="standard-basic"
                        inputRef={otp3Ref}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) {
                            e.preventDefault();
                            otp3Ref.current.value = "";
                            otp2Ref.current.focus();
                          }
                        }}
                        onChange={(e) => {
                          setinvaildOtp(false);
                          if (
                            e.target.value.length <= 1 &&
                            otp3Ref.current &&
                            dateCheck(e) != ""
                          ) {
                            if (dateCheck(e) != "") {
                              setOtp3(e.target.value);
                              otp4Ref.current.focus();
                            }
                          } else {
                            e.preventDefault();
                            otp3Ref.current.value = "";
                          }
                        }}
                        variant="standard"
                        name="otp_screen"
                      />
                    </div>
                    <div
                      className={`opt_left ${invaildOtp && "otp_error_value"}`}
                    >
                      <TextField
                        id="standard-basic"
                        variant="standard"
                        inputRef={otp4Ref}
                        onKeyDown={(e) => {
                          setinvaildOtp(false);
                          if (
                            (e.target.value.length == 1 && e.key === "Enter") ||
                            e.key === "Tab"
                          ) {
                            handleVerifyOtp();
                          }
                          if (e.keyCode === 8) {
                            e.preventDefault();
                            otp4Ref.current.value = "";
                            otp3Ref.current.focus();
                          }
                        }}
                        onChange={(e) => {
                          if (
                            e.target.value.length <= 1 &&
                            otp4Ref.current &&
                            dateCheck(e) != ""
                          ) {
                            if (dateCheck(e) != "") {
                              setOtp4(e.target.value);
                            }
                          } else {
                            e.preventDefault();
                            otp4Ref.current.value = "";
                          }
                        }}
                        name="otp_screen"
                      />
                    </div>
                  </div>
                  <p className="errText mt-2 text-left ml-1">
                    {invaildOtp && "Incorrect OTP, please re-enter."}
                  </p>
                  <div
                    className="relode_the_buttons"
                    style={{ minHeight: "25px" }}
                  >
                    <Row>
                      <Col sm={6}>
                        {showResend ? (
                          <div
                            className="resend_but"
                            onClick={() => {
                              // HandleOtpVerification()
                              ResendOtp();
                            }}
                          >
                            <Link>Resend the code </Link>
                          </div>
                        ) : (
                          <span></span>
                        )}
                      </Col>
                      <Col sm={6}>
                        <div className="time_count">
                          <labe>
                            {!showResend ? (
                              <OTPTimer
                                durations={time}
                                updateTimer={(v) => {
                                  setTime(0);
                                  setShowResend(v);
                                }}
                              />
                            ) : null}{" "}
                          </labe>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="mt-6">
                    <CustomButton
                      text={"Continue"}
                      onClick={handleVerifyOtp}
                      isLoading={isSubmitting}
                      disabled={isSubmitting}
                      style={{ width: "100%", padding: "8px 0" }}
                    />
                    {/* <Button variant="contained" onClick={() => verifyOtp()} autoFocus disabled={time == 0 ? true : false || loading}
                                                        className={time == 0 ? 'submit_notVaild' : ''}
                                                    >{loading ? <CircularProgress size={'20px'} sx={{ color: "#ffffff" }} /> : 'Continue'}</Button> */}
                  </div>
                </div>
              </form>
            </div>
          </>
        )}
      </div>
    </>
  );
}
